__turbopack_context__.v({
  "dropdown": "chart-code-module__0AtHYa__dropdown",
  "dropdownCategory": "chart-code-module__0AtHYa__dropdownCategory",
  "dropdownCategoryTitle": "chart-code-module__0AtHYa__dropdownCategoryTitle",
  "dropdownCurrency": "chart-code-module__0AtHYa__dropdownCurrency",
  "dropdownName": "chart-code-module__0AtHYa__dropdownName",
  "dropdownRow": "chart-code-module__0AtHYa__dropdownRow",
  "dropdownSymbol": "chart-code-module__0AtHYa__dropdownSymbol",
  "input": "chart-code-module__0AtHYa__input",
  "label": "chart-code-module__0AtHYa__label",
  "tag": "chart-code-module__0AtHYa__tag",
  "tagContainer": "chart-code-module__0AtHYa__tagContainer",
  "urlContainer": "chart-code-module__0AtHYa__urlContainer",
  "urlTextarea": "chart-code-module__0AtHYa__urlTextarea",
});
